<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title" i18n>Review Automations</h6>
          <app-page-help articleId="mHuYHxf3YFQW5LpG4ZPvbC"></app-page-help>
        </div>
        <div class="flex-fill"></div>

        <app-automations-table-actions [table]="automations?.table"></app-automations-table-actions>
        <button (click)="onAddAutomation()" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info">
          <span class="far fa-plus"></span>
          <ng-container i18n>Add Automation</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <app-review-automations [viewType]="'list'" #automations></app-review-automations>
    </div>
  </div>
</div>
